import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconPip } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { togglePip } from '../../actions';
/**
 * Opens or closes Picture-in-Picture using the implementation supported by the browser.
 */
class PiPTriggerButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.pip';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.pipClose';
    label = 'toolbar.pip';
    toggledLabel = 'toolbar.pipClose';
    tooltip = 'toolbar.pip';
    toggledTooltip = 'toolbar.pipClose';
    icon = IconPip;
    /**
     * Indicates whether the button is toggled.
     *
     * @returns {boolean}
     */
    _isToggled() {
        return Boolean(this.props._isPiPActive);
    }
    /**
     * Handles toggling Picture-in-Picture.
     *
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('toggle.pip', { enable: !this._isToggled() }));
        dispatch(togglePip());
    }
}
/**
 * Maps Redux state to component props.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _isPiPActive: Boolean(state['features/pip']?.isPiPActive)
    };
}
export default translate(connect(mapStateToProps)(PiPTriggerButton));
